import React, { useRef, useState } from 'react';
import styled from '@emotion/styled';
import axios from 'axios';
import ReactToPrint from 'react-to-print';
import { Loader } from 'semantic-ui-react';
import { PrintButton } from '../ProofingReport/styled';
import { PrintIcon } from 'components/ui/icons';
import Filters from './Components/Filters';
import TableWrapper from './Components/TableWrapper';
import { TaxMapReportOrder } from './types';

const ReportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const PrintView = styled.div`
  .totalResults {
    display: none;
  }
  @media print {
    .report {
      padding: 15px;
    }
    .totalResults {
      display: block;
    }
    .tableTwelve td {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0.2em 0.3em 0.2em 1.3em !important;
    }
  }
`;

const TaxMapReport = () => {
  const [reportData, setReportData] = useState<TaxMapReportOrder[]>([]);
  const [showReport, setShowReport] = useState(false);
  const [reqString, setReqString] = useState<string>();
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);

  const onSubmit = async (queryString: string) => {
    setLoading(true);
    try {
      const { data } = await axios.get(`/api/reports/taxMapReport?${queryString || reqString}`);

      if (!Array.isArray(data)) {
        return;
      }

      setReportData(data);
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ReportWrapper>
      <h1>Tax Map Report</h1>
      <Filters setReqString={setReqString} onSubmit={onSubmit} loading={loading} />
      {showReport && (
        <div style={{ display: 'flex', gap: 20, alignItems: 'center', margin: '20px 0px' }}>
          <div style={{ fontSize: 14 }}>{`Total Orders: ${reportData.length}`}</div>
          <ReactToPrint
            trigger={() => (
              <PrintButton>
                <PrintIcon />
              </PrintButton>
            )}
            content={() => tableRef.current}
          />
        </div>
      )}
      {showReport && loading && <Loader active size="large" inline="centered" />}
      {showReport && (
        <div className="report" ref={tableRef}>
          <PrintView>
            <TableWrapper reportData={reportData} />
            <div
              className="totalResults"
              style={{ fontSize: 14 }}
            >{`Total Orders: ${reportData.length}`}</div>
          </PrintView>
        </div>
      )}
    </ReportWrapper>
  );
};

export default TaxMapReport;
